import { DNDQ_SET_SEQUENCE, DNDQ_SUBMIT } from "../../Redux.constants";
import { selectNewSliderSequence } from "./SelectNewSliderSequence";
import { submitAnswer } from "./SubmitAnswer";

export function DNDQReducer(state = {}, action) {
  switch (action.type) {
    case DNDQ_SET_SEQUENCE:
      return selectNewSliderSequence(state, action.payload);
    case DNDQ_SUBMIT:
      return submitAnswer(state, action.payload);
    default:
      return state;
  }
}
